const TEXT_FADE_DURATION_MS = 250;
const outlineCls = "_rsoca1y0d";
const buttonCls = "_rsb1r3sef1";
const iconCls = "_rsi1r36hm8";
const labelCls = "_rslqbivlw";

export { TEXT_FADE_DURATION_MS, buttonCls, iconCls, labelCls, outlineCls };
import "./ExpandCollapseButton.linaria.module.css";
//# sourceMappingURL=ExpandCollapseButton.js.map
